export default __webpack_public_path__ + "static/media/gallery-wip-pommel_01.8172d192.jpg";